import { useMutation, useQueryClient } from "@tanstack/react-query";

import Modal from "newui/components/ui/Modal/Modal";
import { deleteDocument } from "newui/features/Company/company-api";
import { companyDocumentKeys } from "../companyDocumentKeys";
import { showToast } from "utils/helpers";

interface DeleteDocumentModalProps {
	companyId: number;
	documentId: number;
	documentName: string;
	isOpen: boolean;
	onClose: () => void;
}

export const DeleteDocumentModal: React.FC<DeleteDocumentModalProps> = ({
	companyId,
	documentId,
	documentName,
	isOpen,
	onClose,
}) => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: () => deleteDocument(companyId, documentId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: companyDocumentKeys.documents(companyId),
			});
			showToast("Document successfully deleted.", "Success", true);
			onClose();
		},
		onError: () => {
			showToast("Failed to delete document. Please try again.", "Error");
		},
	});

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Delete Document"
			iconType="warning"
			modalType="alert"
			description={`Are you sure you want to delete "${documentName}"? This action cannot be undone.`}
			primaryButton={{
				text: mutation.isPending ? "Deleting..." : "Delete",
				btntype: "primary",
				onClick: () => mutation.mutate(),
				isLoading: mutation.isPending,
				disabled: mutation.isPending,
			}}
			secondaryButton={{
				text: "Cancel",
				btntype: "secondary",
				onClick: onClose,
				disabled: mutation.isPending,
			}}
		>
			<></>
		</Modal>
	);
};
